module.exports = __webpack_public_path__ + "img/1440.66853bee.jpg";